import React from 'react';
import { BsFiletypeCsv } from 'react-icons/bs';

import { Icon } from '@/components/icon/icon';

import styles from '../../contractDetails.module.scss';

interface ModelField {
  type?: string;
  primary?: boolean;
  required?: boolean;
  unique?: boolean;
}

interface Model {
  description?: string;
  fields?: Record<string, ModelField>;
}

interface DataTypeDescriptionsTabProps {
  models: Record<string, Model>;
}

export function DataTypeDescriptionsTab( { models }: DataTypeDescriptionsTabProps ) {
  return (
    <div className={ styles.tabPanel } data-testid='panel-data-type-descriptions'>
      { Object.entries( models ).map( ( [ modelName, model ] ) => (
        <div key={ modelName } className={ styles.dataTypeSection }>
          <div className={ styles.dataTypeHeader }>
            <div className={ styles.dataTypeTitleRow }>
              <Icon icon={ BsFiletypeCsv } size="md" />
              <h4 className={ styles.dataTypeTitle }>{ modelName }</h4>
            </div>
            { model.description && (
              <p className={ styles.dataTypeDescription }>{ model.description }</p>
            ) }
          </div>
          { model.fields && Object.keys( model.fields ).length > 0 && (
            <div className={ styles.dataTypeTable }>
              <table>
                <thead>
                  <tr>
                    <th>Data</th>
                    <th>Type</th>
                    <th>Description</th>
                  </tr>
                </thead>
                <tbody>
                  { Object.entries( model.fields ).map( ( [ fieldName, field ] ) => {
                    const attributes = [];
                    if ( field.primary ) attributes.push( 'primary' );
                    if ( field.required ) attributes.push( 'required' );
                    if ( field.unique ) attributes.push( 'unique' );
                    const description = attributes.length > 0 ? attributes.join( ', ' ) : '-';

                    return (
                      <tr key={ fieldName }>
                        <td>{ fieldName }</td>
                        <td>{ field.type || '-' }</td>
                        <td>{ description }</td>
                      </tr>
                    );
                  } ) }
                </tbody>
              </table>
            </div>
          ) }
        </div>
      ) ) }
    </div>
  );
}
